import React, { useState, useCallback } from 'react';
import { DashboardContainer } from '../../components/ui/UtilsLayout';
import { useNavigate } from 'react-router-dom';
import { not_list } from '../../utils/constant';

const Notifications = () => {
  const [selectedItem, setSelectedItem] = useState(1);
  const navigate = useNavigate();

  // Handle Notification Selection (Memoized for Performance)
  const handleNotificationClick = useCallback(
    (index, notification) => {
      if (window.innerWidth < 768) {
        navigate('/dashboard/notification-details', { state: notification });
      } else {
        setSelectedItem(index);
      }
    },
    [navigate]
  );

  return (
    <DashboardContainer>
      <div className="h-full w-full flex gap-3">
        {/* Left Sidebar - Notification List */}
        <div className="h-full min-w-full md:min-w-[380px] bg-[#1E1F22] p-4 rounded-lg">
          <div className="overflow-auto custom-scrollbar  h-full py-3">
            <div className="pr-4 flex flex-col gap-3">
              {not_list.map((notification, index) => (
                <div
                  key={index}
                  onClick={() => handleNotificationClick(index, notification)}
                  className={`cursor-pointer flex justify-between relative bg-[#29292C] py-2 px-4 rounded-lg border 
                    ${
                      selectedItem === index
                        ? 'border-[#939090]'
                        : 'border-transparent'
                    }`}
                >
                  {/* Profile Icon / Initial */}
                  <div className="flex gap-4">
                    <div
                      className="w-[53px] h-[53px] rounded-full flex justify-center items-center p-1"
                      style={{ backgroundColor: notification?.bg }}
                    >
                      {notification?.type !== 'Platform Updates' && (
                        <div className="text-[24px] border-4 border-black h-full w-full rounded-full flex justify-center items-center">
                          {notification?.name[0]?.toUpperCase()}
                        </div>
                      )}
                    </div>
                    <div className="flex flex-col gap-1">
                      <div className="text-[15px] font-bold">
                        {notification?.name}
                      </div>
                      <div className="text-[13px]">{notification?.type}</div>
                    </div>
                  </div>
                  {/* Notification Time */}
                  <div className="text-[#E9E9E9] text-[11px]">
                    {notification?.time}
                  </div>
                  {/* Important Indicator */}
                  {notification?.imp && (
                    <div className="h-[13px] w-[13px] absolute -top-1 -right-0 bg-[#EE2B2A] rounded-full" />
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Right Sidebar - Notification Details (Only for Desktop) */}
        <div className="hidden md:block min-h-full flex-1 bg-[#1E1F22] p-4 xl:px-16 rounded-lg">
          {not_list[selectedItem] && (
            <>
              <div className="text-[24px] font-bold">
                From: {not_list[selectedItem]?.name}
              </div>
              <div className="text-[16px] text-[#E9E9E9] font-light">
                {not_list[selectedItem]?.time}
              </div>
              <div className="mt-10 font-semibold">
                {not_list[selectedItem]?.mess}
              </div>
              <div className="mt-4 leading-[45px] font-bold text-[16px] w-full">
                {not_list[selectedItem]?.desc}
              </div>
            </>
          )}
        </div>
      </div>
    </DashboardContainer>
  );
};

export default Notifications;
